export const TenderModel = {
    tender_title:'',
    type:'',
    upload_date: '',
    open_date: '',
    validity:'',
    open_time:'',
    is_local:0,
    tender_details: [],
    attachements: []
}

export const TENDER_STATUS_JUST_PLACED = 1;
export const TENDER_STATUS_APPROVED = 2;
export const TENDER_STATUS_CLOSED = 3;
export const TENDER_STATUS_HOD_APPROVED = 4;

export const TENDER_OPEN=1;
export const TENDER_CLOSED=0;

// voucher status
export const IS_LOCAL_YES = 1;
export const IS_LOCAL_NO = 2;

export const IS_LOCAL_NAME = {
    1: 'Yes',
    2: 'No',
};

export const IS_LOCAL_DROPDOWN_OPTIONS = [
    { value: IS_LOCAL_YES, label: IS_LOCAL_NAME[IS_LOCAL_YES] },
    { value: IS_LOCAL_NO, label: IS_LOCAL_NAME[IS_LOCAL_NO] },
];


export const TYPE_PURCHASE = 1;
export const TYPE_SALE = 2;

export const TYPE_NAMES = {
    1: 'Purchase',
    2: 'Sale',
};

export const TYPE_DROPDOWN_OPTIONS = [
    { value: TYPE_PURCHASE, label: TYPE_NAMES[TYPE_PURCHASE] },
    { value: TYPE_SALE, label: TYPE_NAMES[TYPE_SALE] },
];